import { TabBar, TabBarItem } from "react-native-tab-view";
import VDBText from "@components/atoms/Text";
import { Platform, View } from "react-native";
import React from "react";
import styled, { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import { CoachOverlayStep } from "@components/CoachOverlay";
import { useOverlayConfig } from "@redux/slices/globalSlice";
import { DefaultTheme } from "styled-components/native";
type VDBTabBarProps = {
  tabBarProps: any;
  props: any;
  onUserTabPress?: () => void;
};

export const VDBTabBar = ({
  tabBarProps,
  props,
  onUserTabPress,
}: VDBTabBarProps) => {
  const theme = useTheme();
  const getOverlayConfig = useOverlayConfig();
  const typography = useTypographyStore();

  return (
    <Container addPadding={props?.addPadding}>
      <TabBar
        {...tabBarProps}
        setPage={tabBarProps.setPage}
        onTabPress={() => onUserTabPress?.()}
        tabStyle={
          !tabBarProps.fullWidth
            ? {
                alignSelf: Platform.select({ android: "flex-start" }),
                width:
                  Platform.OS === "android" &&
                  tabBarProps?.navigationState?.routes?.length === 1
                    ? undefined
                    : "auto",
                paddingHorizontal: SpaceType.Double,
                minHeight: 62,
              }
            : null
        }
        scrollEnabled={false}
        pressColor="white"
        pressOpacity={1}
        renderTabBarItem={({ key, ...tabProps }) => (
          <TabBarItem
            key={key}
            {...tabProps}
            label={({ route, labelText, focused }) => (
              <CoachOverlayStep
                screen="ExploreScreen"
                stepKey="tabBar"
                text={
                  getOverlayConfig.screens.ExploreScreen?.steps[1]?.text ||
                  "Default tab overlay"
                }
                order={2}
                active={route.key === "saved_searches"}
              >
                <TextViewContainer>
                  <VDBText
                    type={focused ? typography["H2-M"] : typography["H2-R"]}
                    numberOfLines={1}
                    color={focused ? theme["core-05"] : theme["core-06"]}
                  >
                    {labelText}
                    {props?.badge && (
                      <View style={{ paddingLeft: 5 }}>
                        <VDBText
                          type={typography["Body-R"]}
                          color={focused ? theme["core-05"] : theme["core-06"]}
                        >
                          {props?.badgeCount}
                        </VDBText>
                      </View>
                    )}
                  </VDBText>
                </TextViewContainer>
              </CoachOverlayStep>
            )}
          />
        )}
        style={{
          backgroundColor: theme["core-01"],
          height: "100%",
          boxShadow: "none",
        }}
        activeColor={theme["core-05"]}
        inactiveColor={theme["core-06"]}
        {...(tabBarProps?.navigationState?.routes?.length > 1
          ? {
              renderIndicator: (tabProps) => (
                <TabBarIndicator
                  width={tabProps.getTabWidth(tabProps.navigationState.index)}
                  left={
                    tabProps.navigationState.index > 0
                      ? [
                          ...Array(tabProps.navigationState.index).keys(),
                        ].reduce((a, b) => a + tabProps.getTabWidth(b), 0)
                      : 0
                  }
                />
              ),
            }
          : {
              indicatorStyle: { backgroundColor: "transparent" },
              display: "none",
            })}
      />
    </Container>
  );
};

export default VDBTabBar;

const Container = styled.View<any>`
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
  padding-left: ${({
    theme,
    addPadding,
  }: {
    theme: DefaultTheme;
    addPadding?: boolean;
  }) => (!theme.isMobile && addPadding ? "30px" : "0px")};
  padding-right: ${({
    theme,
    addPadding,
  }: {
    theme: DefaultTheme;
    addPadding?: boolean;
  }) => (!theme.isMobile && addPadding ? "30px" : "0px")};
  height: 62px;
`;

const TabBarIndicator = styled.View<{ width: number; left: number }>`
  height: 3px;
  width: ${({ width }: { width: number }) => width}px;
  position: absolute;
  bottom: 0;
  left: ${({ left }: { left: number }) => left}px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["extra-02"]};
`;

const TextViewContainer = styled.View`
  flex-wrap: wrap;
  align-self: flex-start;
  height: 100%;
  justify-content: center;
`;
